import { DateTime } from 'luxon';

export function parseAttributes(raw) {
  if (!raw) return {};
  if (typeof raw === 'object') return raw;
  try { return JSON.parse(raw); } catch { return {}; }
}

export function extractSkills(attrs) {
  return attrs?.routing?.skills && Array.isArray(attrs.routing.skills) ? attrs.routing.skills : [];
}

export function skillsDiff(prevSkills, currSkills) {
  const added = currSkills.filter(s => !prevSkills.includes(s));
  const removed = prevSkills.filter(s => !currSkills.includes(s));
  const changed = added.length > 0 || removed.length > 0 || prevSkills.length !== currSkills.length;
  return { added, removed, changed };
}

export function formatTimestamp(ts) {
  if (!ts) return '';
  return DateTime.fromISO(ts).toFormat('yyyy-LL-dd HH:mm:ss');
}

export function buildDescription(prevSkills, currSkills) {
  const { added, removed } = skillsDiff(prevSkills, currSkills);
  // If there were no previous skills and now there are, treat as an addition (not a baseline line)
  if (!prevSkills.length && currSkills.length) {
    return {
      jsx: <>
        <b>Toegevoegd: {currSkills.join(', ')}</b>
        {currSkills.length > 0 && <><br /><span>Nieuwe skills: {currSkills.join(', ')}</span></>}
      </>,
      text: `toegevoegd: ${currSkills.join(', ')}${currSkills.length ? ` nieuwe skills: ${currSkills.join(', ')}` : ''}`
    };
  }
  if (added.length) {
    return {
      jsx: <>
        <b>Toegevoegd: {added.join(', ')}</b>
        {currSkills.length > 0 && <><br /><span>Nieuwe skills: {currSkills.join(', ')}</span></>}
      </>,
      text: `toegevoegd: ${added.join(', ')}${currSkills.length ? ` nieuwe skills: ${currSkills.join(', ')}` : ''}`
    };
  }
  if (removed.length) {
    return {
      jsx: <>
        <b>Verwijderd: {removed.join(', ')}</b>
        {currSkills.length > 0 && <><br /><span>Nieuwe skills: {currSkills.join(', ')}</span></>}
      </>,
      text: `verwijderd: ${removed.join(', ')}${currSkills.length ? ` nieuwe skills: ${currSkills.join(', ')}` : ''}`
    };
  }
  // No changes -> return an empty description (these rows should typically be filtered out upstream)
  return { jsx: <></>, text: '' };
}
